'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FactboxHeader = function FactboxHeader(_ref) {
    var title = _ref.title,
        theme = _ref.theme,
        isExpanded = _ref.isExpanded,
        onToggleExpanded = _ref.onToggleExpanded,
        contentId = _ref.contentId,
        i18n = _ref.i18n,
        attributes = _ref.attributes;

    var TitleWrapper = onToggleExpanded ? 'span' : 'h2';
    var StreamerWrapper = onToggleExpanded ? 'span' : 'h1';
    var TitleTag = title && _react2.default.createElement(
        TitleWrapper,
        { className: theme.title },
        title.value
    );
    var StreamerTag = _react2.default.createElement(
        StreamerWrapper,
        { className: theme.streamer },
        i18n.heading
    );

    if (onToggleExpanded) {
        return _react2.default.createElement(
            'h2',
            { className: theme.header },
            _react2.default.createElement(
                'button',
                (0, _extends3.default)({}, attributes({ elementName: 'factboxHeaderButton' }), {
                    className: theme.headerClickable, onClick: onToggleExpanded,
                    'aria-expanded': isExpanded, 'aria-controls': contentId
                }),
                StreamerTag,
                TitleTag
            )
        );
    }
    return _react2.default.createElement(
        'header',
        { className: theme.header },
        StreamerTag,
        TitleTag
    );
};

FactboxHeader.propTypes = {
    attributes: _propTypes2.default.func.isRequired,
    isExpanded: _propTypes2.default.bool.isRequired,
    title: _propTypes2.default.shape({
        value: _propTypes2.default.string
    }).isRequired,
    theme: _propTypes2.default.shape({
        header: _propTypes2.default.string,
        streamer: _propTypes2.default.string,
        title: _propTypes2.default.string,
        headerClickable: _propTypes2.default.string
    }).isRequired,
    onToggleExpanded: _propTypes2.default.func,
    contentId: _propTypes2.default.string,
    i18n: _propTypes2.default.shape({
        heading: _propTypes2.default.string,
        readMore: _propTypes2.default.string,
        readLess: _propTypes2.default.string
    }).isRequired

};

FactboxHeader.defaultProps = {
    attributes: function attributes() {
        return {};
    },
    onToggleExpanded: undefined,
    isExpanded: false,
    contentId: ''
};

exports.default = FactboxHeader;
//# sourceMappingURL=FactboxHeader.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/FactboxHeader/FactboxHeader.js
 ** module id = 514
 ** module chunks = 1
 **/